export enum OpCoRetailSubscriptionEnum{
    NotParticipating = 11,
    OperatingCountryLevel = 12,
    StoreLevel = 13
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/op-co-retail-subscription.enum.ts